




// 项目统计

//统计信息
import StatisticalInfo from "./modular/statisticalInfo.vue";

//各状态的项目分布图
import ProjectDistribution from "./modular/projectDistribution.vue";

//各部门申报的项目
import DepartmentalDeclaration from "./modular/departmentalDeclaration.vue";

//各类型单位申报的项目
import UnitDeclaration from "./modular/unitDeclaration.vue";


//走访统计

//各区县走访的项目
import VisitProjectCounty from "./modular/visitProjectCounty.vue";

//各类型单位走访的项目
import VisitProjectUnit from "./modular/visitProjectUnit.vue";

export default { StatisticalInfo,ProjectDistribution,DepartmentalDeclaration,UnitDeclaration ,VisitProjectCounty,VisitProjectUnit};
